import { configuration } from 'mmfintech-checkout-commons'
import { isBase64EncodedImage } from 'mmfintech-commons'

import { BankIcon as SingleBankIcon } from '@icons'

import type { SupportedBank } from 'mmfintech-checkout-commons/types'

import BankGroupIcon from '@assets/icons/bank-group.png'

type BankIconProps = {
  bank: SupportedBank
}

export const BankIcon = ({ bank }: BankIconProps) => {
  if (bank?.logoUrl) {
    return (
      <img
        src={
          isBase64EncodedImage(bank.logoUrl) || bank.logoUrl.substring(0, 4) === 'http'
            ? bank.logoUrl
            : `${configuration.readBackendConfig()}${bank.logoUrl}`
        }
        alt=''
      />
    )
  }

  return Array.isArray(bank.options) && bank.options.length ? <img src={BankGroupIcon} alt='' /> : <SingleBankIcon />
}
